<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal mx-6 pt-6">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">财富数据授权</h1>
            <p class="list-page-description">管理财富客户、合同、批次、申请、流水和统计的数据查看范围。</p>
          </div>
          <div class="list-page-heading-actions">
            <button v-permission="'wealth:data-permission:manage'" class="btn-primary" @click="openCreate">新增授权</button>
          </div>
        </div>
      </div>
    </template>

    <template #filters>
      <PageFilterBar class="mx-6" body-class="p-5" :show-refresh="true" :refresh-loading="loading" @refresh="loadPermissions">
        <div class="w-64">
          <label class="filter-label">授权用户</label>
          <UserSelector v-model="filters.userId" class="selector-compact" :multiple="false" placeholder="选择用户" />
        </div>
        <div class="w-36">
          <label class="filter-label">授权范围</label>
          <select v-model="filters.scopeType" class="form-select-native form-control-sm w-full"><option value="">全部</option><option value="DEPT">部门</option><option value="TENANT">全租户</option></select>
        </div>
        <div class="w-64">
          <label class="filter-label">授权部门</label>
          <DeptSelector v-model="filters.dept" class="selector-compact" :multiple="false" placeholder="选择部门" />
        </div>
        <div class="w-36">
          <label class="filter-label">状态</label>
          <select v-model="filters.status" class="form-select-native form-control-sm w-full"><option value="">全部</option><option value="ACTIVE">启用</option><option value="DISABLED">停用</option></select>
        </div>
        <template #searchActions>
          <button class="btn-primary" @click="handleSearch">搜索</button>
          <button class="btn-secondary" @click="handleReset">重置</button>
        </template>
      </PageFilterBar>
    </template>

    <div class="list-page-table-panel mx-6">
      <div class="data-table-shell">
        <div class="data-table-scroll">
          <table class="data-table text-sm">
            <thead class="data-table-head"><tr><th class="data-table-th text-left">用户ID</th><th class="data-table-th text-left">授权范围</th><th class="data-table-th text-left">部门ID</th><th class="data-table-th text-left">状态</th><th class="data-table-th text-left">创建时间</th><th class="data-table-th text-center">操作</th></tr></thead>
            <tbody>
              <tr v-if="loading"><td colspan="6" class="data-table-empty">加载中...</td></tr>
              <tr v-else-if="rows.length === 0"><td colspan="6" class="data-table-empty">暂无授权</td></tr>
              <tr v-for="row in rows" v-else :key="row.id" class="data-table-row">
                <td class="data-table-td">{{ row.userId }}</td>
                <td class="data-table-td"><WealthStatusBadge type="scope" :value="row.scopeType" /></td>
                <td class="data-table-td">{{ row.deptId || '-' }}</td>
                <td class="data-table-td"><WealthStatusBadge type="permission" :value="row.status" /></td>
                <td class="data-table-td text-xs">{{ formatDateTime(row.createTime) }}</td>
                <td class="data-table-td is-center">
                  <button v-if="row.status === 'ACTIVE'" v-permission="'wealth:data-permission:manage'" class="table-action-button is-danger" title="停用" @click="changeStatus(row, 'disable')">
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364L5.636 5.636"/></svg>
                  </button>
                  <button v-else v-permission="'wealth:data-permission:manage'" class="table-action-button is-success" title="启用" @click="changeStatus(row, 'enable')">
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <AppPagination v-if="pagination.total > 0" class="pagination-bridge" :pagination="pagination" :page-sizes="PAGE_SIZE_OPTIONS" mode="simple" @page-change="handlePageChange" @size-change="handleSizeChange" />
    </div>

    <Teleport to="body">
      <div v-if="formVisible" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-black/50" @click="formVisible = false"></div>
        <div class="relative flex min-h-screen items-center justify-center p-4">
          <div class="relative w-full max-w-lg rounded-lg bg-white shadow-xl">
            <div class="border-b border-slate-200 px-6 py-4"><h3 class="text-lg font-semibold text-slate-900">新增财富数据授权</h3></div>
            <div class="space-y-4 p-6">
              <label class="block">
                <span class="form-label">授权用户 <span class="text-red-500">*</span></span>
                <UserSelector v-model="form.userId" :multiple="false" placeholder="选择授权用户" />
              </label>
              <label class="block"><span class="form-label">授权范围 <span class="text-red-500">*</span></span><select v-model="form.scopeType" class="form-select-native w-full"><option value="DEPT">部门</option><option value="TENANT">全租户</option></select></label>
              <label v-if="form.scopeType === 'DEPT'" class="block">
                <span class="form-label">授权部门 <span class="text-red-500">*</span></span>
                <DeptSelector v-model="form.dept" :multiple="false" placeholder="选择授权部门" />
              </label>
            </div>
            <div class="flex justify-end gap-3 border-t border-slate-200 px-6 py-4">
              <button class="btn-secondary" @click="formVisible = false">取消</button>
              <button class="btn-primary" @click="submit">保存</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </ListPageShell>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import AppPagination from '@/components/AppPagination.vue'
import UserSelector from '@/components/UserSelector/index.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import DeptSelector from '@/views/system/components/DeptSelector/index.vue'
import { disableWealthDataPermission, enableWealthDataPermission, getWealthDataPermissionPage, saveWealthDataPermission } from '@/api/wealth'
import WealthStatusBadge from '../components/WealthStatusBadge.vue'
import { cleanPayload, formatDateTime, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils'

const filters = reactive({ userId: null, scopeType: '', dept: null, status: '' })
const pagination = reactive({ current: 1, page: 1, size: 10, total: 0, pages: 1 })
const rows = ref([])
const loading = ref(false)
const formVisible = ref(false)
const form = reactive({ userId: null, scopeType: 'DEPT', dept: null })

function extractId(value) {
  if (Array.isArray(value)) {
    return extractId(value[0])
  }
  if (value && typeof value === 'object') {
    return value.id
  }
  return value || null
}

function permissionQueryPayload() {
  return cleanPayload({
    userId: extractId(filters.userId),
    scopeType: filters.scopeType,
    deptId: extractId(filters.dept),
    status: filters.status
  })
}

async function loadPermissions() {
  loading.value = true
  try {
    const result = await getWealthDataPermissionPage(pagePayload(pagination, permissionQueryPayload()))
    rows.value = result?.records || []
    syncPageResult(pagination, result)
  } finally {
    loading.value = false
  }
}
function handleSearch() { pagination.current = 1; pagination.page = 1; loadPermissions() }
function handleReset() { Object.assign(filters, { userId: null, scopeType: '', dept: null, status: '' }); handleSearch() }
function handlePageChange(page) { pagination.current = page; pagination.page = page; loadPermissions() }
function handleSizeChange(size) { pagination.size = size; handleSearch() }
function openCreate() { Object.assign(form, { userId: null, scopeType: 'DEPT', dept: null }); formVisible.value = true }
async function submit() {
  const userId = extractId(form.userId)
  const deptId = extractId(form.dept)
  if (!userId || !form.scopeType || (form.scopeType === 'DEPT' && !deptId)) {
    ElMessage.warning('请选择授权用户和范围')
    return
  }
  await saveWealthDataPermission(cleanPayload({ userId, scopeType: form.scopeType, deptId: form.scopeType === 'DEPT' ? deptId : 0 }))
  ElMessage.success('授权已保存')
  formVisible.value = false
  loadPermissions()
}
async function changeStatus(row, action) {
  try {
    await ElMessageBox.confirm(`确认${action === 'disable' ? '停用' : '启用'}该授权吗？`, '授权状态', { confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning' })
    if (action === 'disable') await disableWealthDataPermission(row.id, {})
    else await enableWealthDataPermission(row.id, {})
    ElMessage.success('状态已更新')
    loadPermissions()
  } catch (error) {
    if (error !== 'cancel') console.error(error)
  }
}
watch(() => form.scopeType, (scopeType) => {
  if (scopeType !== 'DEPT') {
    form.dept = null
  }
})
onMounted(loadPermissions)
</script>

<style scoped>
.selector-compact :deep(.dept-wrapper) {
  min-height: 32px;
  max-height: 38px;
  overflow: hidden;
  padding: 3px 8px;
}
</style>
